import api from "./api";

export interface TruckYardOption {
  id: string;
  name: string;
  /**
   * La zona del patio, cuando el documento la declara.
   *
   * Viaja acá porque las pantallas que sólo tienen este catálogo —el historial
   * de inspecciones— necesitan resolver "hoy" con la MISMA zona que el backend
   * usa para interpretar el `YYYY-MM-DD` que le mandan (`resolveYardTimeZone`,
   * yardDateRange.js). Mientras el historial no mandaba `yard_id` daba igual:
   * los dos extremos caían en el mismo fallback `America/Mexico_City`. Ahora el
   * patio viaja (#496) y el backend resuelve con la zona del patio, así que un
   * cliente que siguiera calculando su "hoy" con el fallback pediría un día
   * distinto del que recibe — el bug de #472, otra vez, del lado del cable.
   */
  timeZone?: string;
}

interface TruckYardOptionApi {
  id: string;
  name?: string;
  yard_name?: string;
  timeZone?: string;
}

export async function fetchTruckYardOptions(
  limit = 100,
): Promise<TruckYardOption[]> {
  const res = await api.get("/truck-yard/yards", {
    params: { limit },
  });

  const yards = Array.isArray(res.data?.data)
    ? (res.data.data as TruckYardOptionApi[])
    : [];

  return yards.map((yard) => ({
    id: yard.id,
    name: yard.name || yard.yard_name || yard.id,
    timeZone: yard.timeZone,
  }));
}
